import { useState } from "react";

function ToolTip({ children, tip, tipCls }) {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div className="relative flex items-center w-fit space-x-2">
      <div
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {children}
      </div>

      {isHovering ? (
        <div
          className={`py-1 px-3 bg-primary rounded-lg shadow-md absolute bottom-[30px] right-0 text-white text-xs ${tipCls}`}
        >
          {tip}
        </div>
      ) : null}
    </div>
  );
}

export default ToolTip;
